// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-1rG8w"};